import useStore from '@/store/store';
import { PAGE_META } from './content';
import { PublicFooter } from './PublicFooter';
import { PublicHeader } from './PublicHeader';
import {
	AreasPreview,
	AudienceCards,
	FinalCta,
	Hero,
	Integrations,
	Interest,
	Solutions,
	Stats,
} from './sections';
import { InterestProvider } from './ui';
import { useHashScroll, usePageMeta } from './usePageMeta';
import './public-site.css';

const SkipLink = () => (
	<a
		href='#main'
		className='sr-only z-[60] rounded-lg bg-white px-4 py-3 font-semibold text-(--dm-navy) shadow-lg focus:not-sr-only focus:fixed focus:top-3 focus:left-3'
	>
		Μετάβαση στο περιεχόμενο
	</a>
);

// The public home page. Logged-in users reach "/" too; they already have the
// app's header, so the public one is only shown to visitors.
// heroShowcase: an alternative hero picture.
// liveShowcase: an alternative picture beside «Όλη η πόλη σε μία οθόνη.» — the
// /3d preview passes its city.
// backdrop: something fixed behind the whole page (the /3d preview's map).
export const PublicHome = ({ heroShowcase, liveShowcase, backdrop } = {}) => {
	const user = useStore(s => s.user);
	usePageMeta(PAGE_META);
	useHashScroll();

	return (
		<InterestProvider>
			<div className={backdrop ? 'dm-site dm-site--3d' : 'dm-site'}>
				{backdrop}
				{!user && <SkipLink />}
				{!user && <PublicHeader />}
				<main id='main' className={user ? '[&>section:first-child]:pt-12' : undefined}>
					<Hero showcase={heroShowcase} />
					<AudienceCards />
					<Solutions liveShowcase={liveShowcase} />
					<Integrations />
					<Stats />
					<AreasPreview />
					<Interest />
					<FinalCta />
				</main>
				<PublicFooter />
			</div>
		</InterestProvider>
	);
};
